/** Sign-in error messages, and the reveal toggle secret fields share. */

export default {
	auth: {
		// The reveal toggle on a secret field (the control center's mail password, a license key).
		password: {
			show: "Passwort anzeigen",
			hide: "Passwort verbergen",
		},
		error: {
			login_expired:
				"Die Anmeldung konnte nicht abgeschlossen werden, weil sie nicht mehr gültig war — etwa weil sie länger als 10 Minuten gedauert hat oder der Server zwischendurch neu gestartet wurde. Melden Sie sich erneut an.",
			login_mismatch:
				"Die Anmeldung konnte diesem Browser nicht zugeordnet werden. Versuchen Sie es erneut.",
			idp_error: "Der Identitätsanbieter hat einen Fehler gemeldet. Versuchen Sie es erneut.",
			email_conflict:
				"Unter dieser E-Mail-Adresse existiert bereits ein Konto mit einer anderen Identität.",
			idp_unavailable:
				"Der Identitätsanbieter ist derzeit nicht erreichbar. Versuchen Sie es in Kürze erneut.",
			account_suspended: "Ihr Konto wurde auf diesem Server gesperrt.",
			generic: "Die Anmeldung ist fehlgeschlagen. Versuchen Sie es erneut.",
		},
	},
};
